<br />
@if (!hasRefreshToken && canShowShare()) {
  <div class="center">
    <a
      href="https://sellercentral.amazon.co.jp/apps/authorize/consent?application_id=amzn1.sellerapps.app.2061b3cc-fc3b-48cc-8b52-fd333bc47f68&state=link">
      <p-button
        label="まずはここをクリックしてAmazon連携を行ってください"
        styleClass="p-button-danger p-button-lg"></p-button>
    </a>
  </div>
}
<h2 class="center">
  「{{ groupName }}」のらくじゃんへようこそ
  <!-- changelogが別用途だと意味わからなくなるのでコメントアウト
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-bell"
    class="p-button-rounded p-button-warning p-button-outlined"
    style="font-size: 2rem"
    severity="danger"
  (click)="goHistory()"></button>
  <p-badge
    *ngIf="showNewIcon()"
    value="New"
    severity="danger"
  size="null"></p-badge>
--></h2>

@for (feature of userFeatures; track feature) {
  <div class="grid">
    <div class="col-1 lg:col-3 xl:col-3"></div>
    <div class="col-5 lg:col-3 xl:col-3">
      <p-card
        class="clickable"
        routerLink="{{ feature[0].path }}">
        <div class="center">
          <i class="pi {{ feature[0].icon }} icon-big"></i>
        </div>
        <h2 class="center">{{ feature[0].title }}</h2>
      </p-card>
    </div>
    @if (getFeatureIndex(1, feature)) {
      <div class="col-5 lg:col-3 xl:col-3">
        <p-card
          class="clickable"
          routerLink="{{ getFeatureIndex(1, feature)?.path }}">
          <div class="center">
            <i class="pi {{ getFeatureIndex(1, feature)?.icon }} icon-big"></i>
          </div>
          <h2 class="center">{{ getFeatureIndex(1, feature)?.title }}</h2>
        </p-card>
      </div>
    }
    <div class="col-1 lg:col-3 xl:col-3"></div>
    <!--
    <div class="col-3"></div>
    <div class="col-3">
      <p-card class="clickable" routerLink="/products/manage" *ngIf="isAdmin">
        <div class="center">
          <i class="pi pi-list icon-big"></i>
        </div>
        <h2 class="center">
          商品管理
        </h2>
      </p-card>
    </div>
    <div class="col-3"></div>
    -->
  </div>
}
